export const StandardComp = ({content,onClick,style,editClass, key= "",editable = false}) => {
    return(
        <div onClick={onClick} className={`standard-comp ${editClass}`} style={style} key={key} editable ={editable} >
            {content}
        </div>
    ) 
}